import type { Region } from "@/types/geodata";

export function TimelineRibbon({ region }: { region: Region }) {
  return (
    <div className="rounded-md border bg-card p-3">
      <p className="text-xs uppercase text-muted-foreground">Timeline</p>
      <div className="mt-4 grid grid-cols-3 gap-2">
        {region.timeline.map((item) => (
          <div key={`${item.date}-${item.label}`} className="relative border-l border-red-400/50 pl-3">
            <p className="text-xs text-muted-foreground">{new Date(item.date).toLocaleDateString()}</p>
            <p className="text-sm font-medium">{item.label}</p>
            <p className="text-xs text-red-200">{item.pressureIndex} pressure</p>
          </div>
        ))}
      </div>
    </div>
  );
}
